const countryList = [
  {
    symbol: "AD",
    currency: "EUR",
    polish_name: "Andora",
    english_name: "Andorra",
    root_name: "Principat d'Andorra",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "AE",
    currency: "AED",
    polish_name: "Zjednoczone Emiraty Arabskie",
    english_name: "United Arab Emirates",
    root_name: "Al Im\u0101r\u0101t al \u2018Arab\u012byah al Mutta\u1e25idah",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "AF",
    currency: "AFN",
    polish_name: "Afganistan",
    english_name: "Afghanistan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "AG",
    currency: "XCD",
    polish_name: "Antigua i Barbuda",
    english_name: "Antigua and Barbuda",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "AI",
    currency: "XCD",
    polish_name: "Anguilla",
    english_name: "Anguilla",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "AL",
    currency: "ALL",
    polish_name: "Albania",
    english_name: "Albania",
    root_name: "Republika e Shqip\u00ebrise",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "AM",
    currency: "AMD",
    polish_name: "Armenia",
    english_name: "Armenia",
    root_name: "Hajastan",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "AN",
    currency: "ANG",
    polish_name: "Antyle Niderlandzkie",
    english_name: "Netherlands Antilles",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "AO",
    currency: "AOA",
    polish_name: "Angola",
    english_name: "Angola",
    root_name: "Rep\u00fablica de Angola",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "AR",
    currency: "ARS",
    polish_name: "Argentyna",
    english_name: "Argentina",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "AS",
    currency: "USD",
    polish_name: "Samoa Ameryka\u0144skie",
    english_name: "American Samoa",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "AT",
    currency: "EUR",
    polish_name: "Austria",
    english_name: "Austria",
    root_name: "Osterreich",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "AU",
    currency: "AUD",
    polish_name: "Australia",
    english_name: "Australia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "AW",
    currency: "AWG",
    polish_name: "Aruba",
    english_name: "Aruba",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "AZ",
    currency: "AZN",
    polish_name: "Azerbejd\u017can",
    english_name: "Azerbaijan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BA",
    currency: "BAM",
    polish_name: "Bo\u015bnia i Hercegowina",
    english_name: "Bosnia and Herzegovina",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "BB",
    currency: "BBD",
    polish_name: "Barbados",
    english_name: "Barbados",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BD",
    currency: "BDT",
    polish_name: "Bangladesz",
    english_name: "Bangladesh",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BE",
    currency: "EUR",
    polish_name: "Belgia",
    english_name: "Belgium",
    root_name: "Koninkrijk Belgi\u00eb",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "BF",
    currency: "XOF",
    polish_name: "Burkina Faso",
    english_name: "Burkina Faso",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BG",
    currency: "BGN",
    polish_name: "Bu\u0142garia",
    english_name: "Bulgaria",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "BH",
    currency: "BHD",
    polish_name: "Bahrajn",
    english_name: "Bahrain",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BI",
    currency: "BIF",
    polish_name: "Burundi",
    english_name: "Burundi",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BJ",
    currency: "XOF",
    polish_name: "Benin",
    english_name: "Benin",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BM",
    currency: "USD",
    polish_name: "Bermudy",
    english_name: "Bermuda",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BN",
    currency: "BND",
    polish_name: "Brunei Darussalam",
    english_name: "Brunei",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BO",
    currency: "BOB",
    polish_name: "Boliwia",
    english_name: "Bolivia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BR",
    currency: "BRL",
    polish_name: "Brazylia",
    english_name: "Brasil",
    root_name: "Rep\u00fablica Federativa do Brasil",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BS",
    currency: "BSD",
    polish_name: "Bahamy",
    english_name: "Bahamas",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BT",
    currency: "BTN",
    polish_name: "Bhutan",
    english_name: "Bhutan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BV",
    currency: "NOK",
    polish_name: "Wyspa Bouveta",
    english_name: "Bouvet Island",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BW",
    currency: "BWP",
    polish_name: "Botswana",
    english_name: "Botswana",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "BY",
    currency: "BYN",
    polish_name: "Bia\u0142oru\u015b",
    english_name: "Belarus",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "BZ",
    currency: "BZD",
    polish_name: "Belize",
    english_name: "Belize",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CA",
    currency: "CAD",
    polish_name: "Kanada",
    english_name: "Canada",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CC",
    currency: "AUD",
    polish_name: "Wyspy Kokosowe",
    english_name: "Coco Islands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CD",
    currency: "CDF",
    polish_name: "Demokratyczna Republika Kongo",
    english_name: "Democratic Republic of the Congo",
    root_name: "Repubilika ya K\u00f4ngo ya Dimokalasi ",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CF",
    currency: "XAF",
    polish_name: "Republika \u015arodkowoafryka\u0144ska",
    english_name: "Central African Republic",
    root_name: "R\u00e9publique centrafricaine",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CG",
    currency: "XAF",
    polish_name: "Kongo",
    english_name: "Congo, Republic of",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CH",
    currency: "CHF",
    polish_name: "Szwajcaria",
    english_name: "Switzerland",
    root_name: "Schweiz",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "CI",
    currency: "XOF",
    polish_name: "Wybrze\u017ce Ko\u015bci S\u0142oniowej",
    english_name: "Ivory Coast",
    root_name: "R\u00e9publique de C\u00f4te d'Ivoire",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CK",
    currency: "NZD",
    polish_name: "Wyspy Cooka",
    english_name: "Cook Islands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CL",
    currency: "CLP",
    polish_name: "Chile",
    english_name: "Chile",
    root_name: "Rep\u00fablica de Chile",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CM",
    currency: "XAF",
    polish_name: "Kamerun",
    english_name: "Cameroon",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CN",
    currency: "CNY",
    polish_name: "Chiny",
    english_name: "China",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CO",
    currency: "COP",
    polish_name: "Kolumbia",
    english_name: "Columbia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CR",
    currency: "CRC",
    polish_name: "Kostaryka",
    english_name: "Costarica",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CS",
    currency: "RSD",
    polish_name: "Serbia",
    english_name: "Serbia",
    root_name: "Srbija",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "CU",
    currency: "CUP",
    polish_name: "Kuba",
    english_name: "Cuba",
    root_name: "Rep\u00fablica de Cuba",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CV",
    currency: "CVE",
    polish_name: "Zielony Przyl\u0105dek",
    english_name: "Republic of Cape Verde",
    root_name: "Cabo Verde",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CX",
    currency: "AUD",
    polish_name: "Wyspa Bo\u017cego Narodzenia",
    english_name: "Territory of Christmas Island",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "CY",
    currency: "EUR",
    polish_name: "Cypr",
    english_name: "Cyprus",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "CZ",
    currency: "CZK",
    polish_name: "Republika Czeska",
    english_name: "Czech Republic",
    root_name: "\u010cesk\u00e1 republika",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "DE",
    currency: "EUR",
    polish_name: "Niemcy",
    english_name: "Germany",
    root_name: "Bundesrepublik Deutschland",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "DJ",
    currency: "DJF",
    polish_name: "D\u017cibuti",
    english_name: "Djibouti",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "DK",
    currency: "DKK",
    polish_name: "Dania",
    english_name: "Denmark",
    root_name: "Kongeriget Danmark",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "DM",
    currency: "XCD",
    polish_name: "Dominika",
    english_name: "Dominica",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "DO",
    currency: "DOP",
    polish_name: "Dominikana",
    english_name: "Dominican Republic",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "DZ",
    currency: "DZD",
    polish_name: "Algieria",
    english_name: "Algeria",
    root_name: "al-D\u017caza'ir",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "EC",
    currency: "USD",
    polish_name: "Ekwador",
    english_name: "Ecuador",
    root_name: "Ecuador",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "EE",
    currency: "EUR",
    polish_name: "Estonia",
    english_name: "Estonia",
    root_name: "Eesti",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "EG",
    currency: "EGP",
    polish_name: "Egipt",
    english_name: "Egypt",
    root_name: "Misr",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "EH",
    currency: "MAD",
    polish_name: "Sahara Zachodnia",
    english_name: "Western Sahara",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "ER",
    currency: "ERN",
    polish_name: "Erytrea",
    english_name: "Eritrea",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "ES",
    currency: "EUR",
    polish_name: "Hiszpania",
    english_name: "Spain",
    root_name: "Reino de Espana",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "ET",
    currency: "ETB",
    polish_name: "Etiopia",
    english_name: "Ethiopia",
    root_name: "Ye Ethiopia Hizebawi Democraciyawi Republic",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "FI",
    currency: "EUR",
    polish_name: "Finlandia",
    english_name: "Finland",
    root_name: "Suomi",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "FJ",
    currency: "FJD",
    polish_name: "Fid\u017ci Republika",
    english_name: "Fiji",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "FK",
    currency: "FKP",
    polish_name: "Falklandy",
    english_name: "Falkland Islands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "FM",
    currency: "USD",
    polish_name: "MikronezjaMikronezja",
    english_name: "Micronesia, Federated States of",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "FO",
    currency: "DKK",
    polish_name: "Wyspy Owcze",
    english_name: "Faroe Islands",
    root_name: "F\u00f8royar",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "FR",
    currency: "EUR",
    polish_name: "Francja",
    english_name: "France",
    root_name: "R\u00e9publique fran\u00e7aise",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "GA",
    currency: "XAF",
    polish_name: "Gabon",
    english_name: "Gabon",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GB",
    currency: "GBP",
    polish_name: "Wielka Brytania",
    english_name: "Great Britain",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "GD",
    currency: "XCD",
    polish_name: "Grenada",
    english_name: "Grenada",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GE",
    currency: "GEL",
    polish_name: "Gruzja",
    english_name: "Georgia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GF",
    currency: "EUR",
    polish_name: "Gujana Francuska",
    english_name: "French Guiana",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GH",
    currency: "GHS",
    polish_name: "Ghana",
    english_name: "Ghana",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GI",
    currency: "GBP",
    polish_name: "Gibraltar",
    english_name: "Gibraltar",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "GL",
    currency: "DKK",
    polish_name: "Grenlandia",
    english_name: "Greenland",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GM",
    currency: "GMD",
    polish_name: "Gambia",
    english_name: "Gambia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GN",
    currency: "GNF",
    polish_name: "Gwinea",
    english_name: "Guinea",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GP",
    currency: "EUR",
    polish_name: "Gwadelupa",
    english_name: "Guadeloupe",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GQ",
    currency: "XAF",
    polish_name: "Gwinea R\u00f3wnikowa",
    english_name: "Equatorial Guinea",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GR",
    currency: "EUR",
    polish_name: "Grecja",
    english_name: "Greece",
    root_name: "Ell\u00e1da",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "GT",
    currency: "GTQ",
    polish_name: "Gwatemala",
    english_name: "Guatemala",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GU",
    currency: "USD",
    polish_name: "Guam",
    english_name: "Guam",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GW",
    currency: "XOF",
    polish_name: "Gwinea Bissau",
    english_name: "Guinea Bissau",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "GY",
    currency: "GYD",
    polish_name: "Gujana",
    english_name: "Guyana",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "HK",
    currency: "HKD",
    polish_name: "Hongkong",
    english_name: "Hong Kong Special Administrative Region of the People\u2019s Republic of China",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "HM",
    currency: "AUD",
    polish_name: "Wyspy Heard i McDonalda",
    english_name: "Heard Island and McDonal Islands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "HN",
    currency: "HNL",
    polish_name: "Honduras",
    english_name: "Honduras",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "HR",
    currency: "HRK",
    polish_name: "Chorwacja",
    english_name: "Croatia",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "HT",
    currency: "HTG",
    polish_name: "Haiti",
    english_name: "Haiti",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "HU",
    currency: "HUF",
    polish_name: "W\u0119gry",
    english_name: "Hungary",
    root_name: "Magyarorsz\u00e1g",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "ID",
    currency: "IDR",
    polish_name: "Indonezja",
    english_name: "Indonesia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "IE",
    currency: "EUR",
    polish_name: "Irlandia",
    english_name: "Ireland",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "IL",
    currency: "ILS",
    polish_name: "Izrael",
    english_name: "Israel",
    root_name: "Yisra'el",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "IN",
    currency: "INR",
    polish_name: "Indie",
    english_name: "India",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "IO",
    currency: "GBP",
    polish_name: "Brytyjskie Terytorium Oceanu Indyjskiego",
    english_name: "British Indian Ocean Territory",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "IQ",
    currency: "IQD",
    polish_name: "Irak",
    english_name: "Iraq",
    root_name: "Al Iraq",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "IR",
    currency: "IRR",
    polish_name: "Iran",
    english_name: "Iran",
    root_name: "D\u017comhuri-je Eslami-je Iran",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "IS",
    currency: "ISK",
    polish_name: "Islandia",
    english_name: "Iceland",
    root_name: "\u00cdsland",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "IT",
    currency: "EUR",
    polish_name: "W\u0142ochy",
    english_name: "Italy",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "JM",
    currency: "JMD",
    polish_name: "Jamajka",
    english_name: "Jamaica",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "JO",
    currency: "JOD",
    polish_name: "Jordania",
    english_name: "Jordan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "JP",
    currency: "JPY",
    polish_name: "Japonia",
    english_name: "Japan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "KE",
    currency: "KES",
    polish_name: "Kenia",
    english_name: "Kenya",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "KG",
    currency: "KGS",
    polish_name: "Kirgistan",
    english_name: "Kyrgystan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "KH",
    currency: "KHR",
    polish_name: "Kambod\u017ca",
    english_name: "Cambodia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "KI",
    currency: "AUD",
    polish_name: "Kiribati",
    english_name: "Kiribati",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "KM",
    currency: "KMF",
    polish_name: "Komory",
    english_name: "Comoros",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "KN",
    currency: "XCD",
    polish_name: "Saint Kitts i Nevis",
    english_name: "Saint Kitts and Nevis",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "KP",
    currency: "KPW",
    polish_name: "Korea\u0144ska Republika Ludowo-Demokratyczna",
    english_name: "Korea, North",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "KR",
    currency: "KRW",
    polish_name: "Republika Korei",
    english_name: "Daehan-minguk",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "KW",
    currency: "KWD",
    polish_name: "Kuwejt",
    english_name: "Kuwait",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "KY",
    currency: "KYD",
    polish_name: "Kajmany",
    english_name: "Cayman Islands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "KZ",
    currency: "KZT",
    polish_name: "Kazachstan",
    english_name: "Kazakhstan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "LA",
    currency: "LAK",
    polish_name: "Laos",
    english_name: "Laos",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "LB",
    currency: "LBP",
    polish_name: "Liban",
    english_name: "Lebanon",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "LC",
    currency: "XCD",
    polish_name: "Saint Lucia",
    english_name: "Saint Lucia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "LI",
    currency: "CHF",
    polish_name: "Liechtenstein",
    english_name: "Lichtenstein",
    root_name: "F\u00fcrstentum Liechtenstein",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "LK",
    currency: "LKR",
    polish_name: "Sri Lanka",
    english_name: "Sri Lanka",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "LR",
    currency: "LRD",
    polish_name: "Liberia",
    english_name: "Liberia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "LS",
    currency: "LSL",
    polish_name: "Lesotho",
    english_name: "Lesotho",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "LT",
    currency: "EUR",
    polish_name: "Litwa",
    english_name: "Lithuania",
    root_name: "Lietuva",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "LU",
    currency: "EUR",
    polish_name: "Luksemburg",
    english_name: "Luxembourg",
    root_name: "L\u00ebtzebuerg",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "LV",
    currency: "EUR",
    polish_name: "\u0141otwa",
    english_name: "Latvia",
    root_name: "Latvija",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "LY",
    currency: "LYD",
    polish_name: "Libia",
    english_name: "Libya",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MA",
    currency: "MAD",
    polish_name: "Maroko",
    english_name: "Morocco",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MC",
    currency: "EUR",
    polish_name: "Monako",
    english_name: "Monaco",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "MD",
    currency: "MDL",
    polish_name: "Mo\u0142dawia",
    english_name: "Moldova",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "ME",
    currency: "EUR",
    polish_name: "Czarnog\u00f3ra",
    english_name: "Montenegro",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "MG",
    currency: "MGA",
    polish_name: "Madagaskar",
    english_name: "Madagascar",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MH",
    currency: "USD",
    polish_name: "Wyspy Marshalla",
    english_name: "Marshall Islands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MK",
    currency: "MKD",
    polish_name: "Macedonia",
    english_name: "Macedonia",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "ML",
    currency: "XOF",
    polish_name: "Mali",
    english_name: "Mali",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MM",
    currency: "MMK",
    polish_name: "Myanmar (Burma)",
    english_name: "Burma",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MN",
    currency: "MNT",
    polish_name: "Mongolia",
    english_name: "Mongolia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MO",
    currency: "MOP",
    polish_name: "Makau",
    english_name: "Makau",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MP",
    currency: "USD",
    polish_name: "Mariany P\u00f3\u0142nocne",
    english_name: "Northern Marianes",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MQ",
    currency: "EUR",
    polish_name: "Martynika",
    english_name: "Martinique",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MR",
    currency: "MRO",
    polish_name: "Mauretania",
    english_name: "Mauritania",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MS",
    currency: "XCD",
    polish_name: "Montserrat",
    english_name: "Montserrat",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MT",
    currency: "EUR",
    polish_name: "Malta",
    english_name: "Malta",
    root_name: "Repubblika ta' Malta",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "MU",
    currency: "MUR",
    polish_name: "Mauritius",
    english_name: "Mauritius",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MV",
    currency: "MVR",
    polish_name: "Malediwy",
    english_name: "Maldives",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MW",
    currency: "MWK",
    polish_name: "Malawi",
    english_name: "Malawi",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MX",
    currency: "MXN",
    polish_name: "Meksyk",
    english_name: "Mexico",
    root_name: "Estados Unidos Mexicanos",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MY",
    currency: "MYR",
    polish_name: "Malezja",
    english_name: "Malaysia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "MZ",
    currency: "MZN",
    polish_name: "Mozambik",
    english_name: "Mozambique",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "NA",
    currency: "NAD",
    polish_name: "Namibia",
    english_name: "Namibia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "NC",
    currency: "XPF",
    polish_name: "Nowa Kaledonia",
    english_name: "New Caledonia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "NE",
    currency: "XOF",
    polish_name: "Niger",
    english_name: "Niger",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "NF",
    currency: "AUD",
    polish_name: "Norfolk",
    english_name: "Norfolk Island",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "NG",
    currency: "NGN",
    polish_name: "Nigeria",
    english_name: "Nigeria",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "NI",
    currency: "NIO",
    polish_name: "Nikaragua",
    english_name: "Nicaragua",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "NL",
    currency: "EUR",
    polish_name: "Holandia",
    english_name: "Nederland",
    root_name: "Koninkrijk der Nederlanden",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "NO",
    currency: "NOK",
    polish_name: "Norwegia",
    english_name: "Norway",
    root_name: "Kongeriket Norge",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "NP",
    currency: "NPR",
    polish_name: "Nepal",
    english_name: "Nepal",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "NR",
    currency: "AUD",
    polish_name: "Nauru",
    english_name: "Nauru",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "NU",
    currency: "NZD",
    polish_name: "Niue",
    english_name: "Niue",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "NZ",
    currency: "NZD",
    polish_name: "Nowa Zelandia",
    english_name: "New Zealand",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "OM",
    currency: "OMR",
    polish_name: "Oman",
    english_name: "Oman",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "PA",
    currency: "PAB",
    polish_name: "Panama",
    english_name: "Panama",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "PE",
    currency: "PEN",
    polish_name: "Peru",
    english_name: "Peru",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "PF",
    currency: "XPF",
    polish_name: "Polinezja Francuska",
    english_name: "French Polynesia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "PG",
    currency: "PGK",
    polish_name: "Papua Nowa Gwinea",
    english_name: "Papua New Guinea",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "PH",
    currency: "PHP",
    polish_name: "Filipiny",
    english_name: "Philippines",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "PK",
    currency: "PKR",
    polish_name: "Pakistan",
    english_name: "Pakistan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "PL",
    currency: "PLN",
    polish_name: "Polska",
    english_name: "Poland",
    root_name: "Polska",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "PM",
    currency: "EUR",
    polish_name: "Wsp\u00f3lnota Terytorialna Saint-Pierre",
    english_name: "Saint Pierre and Miquelon",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "PN",
    currency: "NZD",
    polish_name: "Pitcairn",
    english_name: "Pitcairn Islands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "PR",
    currency: "USD",
    polish_name: "Portoryko",
    english_name: "Puerto Rico",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "PS",
    currency: "ILS",
    polish_name: "Palesty\u0144skie W\u0142adze Narodowe",
    english_name: "As-Sulta al-Watanijja al-Filastinijja",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "PT",
    currency: "EUR",
    polish_name: "Portugalia",
    english_name: "Portugal",
    root_name: "Rep\u00fablica Portuguesa",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "PW",
    currency: "USD",
    polish_name: "Palau",
    english_name: "Palau",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "PY",
    currency: "PYG",
    polish_name: "Paragwaj",
    english_name: "Paraguay",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "QA",
    currency: "QAR",
    polish_name: "Katar",
    english_name: "Qatar",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "RE",
    currency: "EUR",
    polish_name: "Reunion",
    english_name: "Reunion",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "RO",
    currency: "RON",
    polish_name: "Rumunia",
    english_name: "Romania",
    root_name: "Rom\u00e2nia",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "RU",
    currency: "RUB",
    polish_name: "Rosja",
    english_name: "Russia",
    root_name: "Rossijskaja Federacija",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "RW",
    currency: "RWF",
    polish_name: "Rwanda",
    english_name: "Rwanda",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SA",
    currency: "SAR",
    polish_name: "Arabia Saudyjska",
    english_name: "Saudi Arabia",
    root_name: "As-Su'udijja",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SB",
    currency: "SBD",
    polish_name: "Wyspy Salomona",
    english_name: "Salomon Islands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SC",
    currency: "SCR",
    polish_name: "Seszele",
    english_name: "Seychelles",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SD",
    currency: "SDG",
    polish_name: "Sudan",
    english_name: "Sudan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SE",
    currency: "SEK",
    polish_name: "Szwecja",
    english_name: "Sweden",
    root_name: "Sverige",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "SG",
    currency: "SGD",
    polish_name: "Singapur",
    english_name: "Singapore",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SH",
    currency: "SHP",
    polish_name: "Wyspa \u015awi\u0119tej Heleny",
    english_name: "Saint Helens",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SI",
    currency: "EUR",
    polish_name: "S\u0142owenia",
    english_name: "Slovenia",
    root_name: "Slovenija",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "SJ",
    currency: "NOK",
    polish_name: "Svalbard",
    english_name: "Svalbard",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "SK",
    currency: "EUR",
    polish_name: "S\u0142owacja",
    english_name: "Slovakia",
    root_name: "Slovensko",
    is_in_europe: "1",
    is_in_ue: "1"
  },
  {
    symbol: "SL",
    currency: "SLL",
    polish_name: "Sierra Leone",
    english_name: "Sierra Leone",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SM",
    currency: "EUR",
    polish_name: "San Marino",
    english_name: "San Marino",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "SN",
    currency: "XOF",
    polish_name: "Senegal",
    english_name: "Senegal",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SO",
    currency: "SOS",
    polish_name: "Somalia",
    english_name: "Somalia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SR",
    currency: "SRD",
    polish_name: "Surinam",
    english_name: "Suriname",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "ST",
    currency: "STD",
    polish_name: "Wyspy \u015aw. Tomasza i Ksi\u0105\u017c\u0119ca",
    english_name: "Saint Thomas",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SV",
    currency: "USD",
    polish_name: "Salwador",
    english_name: "Salvador",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SY",
    currency: "SYP",
    polish_name: "Syria",
    english_name: "Syria",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "SZ",
    currency: "SZL",
    polish_name: "Suazi",
    english_name: "Swaziland",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TC",
    currency: "USD",
    polish_name: "Turks i Caicos",
    english_name: "Turks and Caicos Islands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TD",
    currency: "XOF",
    polish_name: "Czad",
    english_name: "Chad",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TF",
    currency: "EUR",
    polish_name: "Francuskie Terytoria Po\u0142udniowe i Antarktyczne",
    english_name: "French Southern and Antarctic Lands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TG",
    currency: "XOF",
    polish_name: "Togo",
    english_name: "Togo",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TH",
    currency: "THB",
    polish_name: "Tajlandia",
    english_name: "Thailand",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TJ",
    currency: "TJS",
    polish_name: "Tad\u017cykistan",
    english_name: "Tajikistan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TK",
    currency: "NZD",
    polish_name: "Tokelau",
    english_name: "Tokelau",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TL",
    currency: "USD",
    polish_name: "Timor Wschodni",
    english_name: "East Timor",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TM",
    currency: "TMT",
    polish_name: "Turkmenistan",
    english_name: "Turkmenistan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TN",
    currency: "TND",
    polish_name: "Tunezja",
    english_name: "Tunisia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TO",
    currency: "TOP",
    polish_name: "Tonga",
    english_name: "Tonga",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TR",
    currency: "TRY",
    polish_name: "Turcja",
    english_name: "Turkey",
    root_name: "T\u00fcrkiye",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "TT",
    currency: "TTD",
    polish_name: "Trynidad i Tobago",
    english_name: "Trinidad and Tobago",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TV",
    currency: "AUD",
    polish_name: "Tuvalu",
    english_name: "Tuvalu",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TW",
    currency: "TWD",
    polish_name: "Tajwan",
    english_name: "Taiwan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "TZ",
    currency: "TZS",
    polish_name: "Tanzania",
    english_name: "Tanzania",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "UA",
    currency: "UAH",
    polish_name: "Ukraina",
    english_name: "Ukraine",
    root_name: "",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "UG",
    currency: "UGX",
    polish_name: "Uganda",
    english_name: "Uganda",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "UM",
    currency: "USD",
    polish_name: "Minor (Powiernicze Wyspy Pacyfiku Stan\u00f3w Zjednoczonych)",
    english_name: "United States Minor Outlying Islands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "US",
    currency: "USD",
    polish_name: "Stany Zjednoczone Ameryki",
    english_name: "United States Of America",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "UY",
    currency: "UYU",
    polish_name: "Urugwaj",
    english_name: "Uruguay",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "UZ",
    currency: "UZS",
    polish_name: "Uzbekistan",
    english_name: "Uzbekistan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "VA",
    currency: "EUR",
    polish_name: "Watykan",
    english_name: "Holy See",
    root_name: "Sancta Sedes",
    is_in_europe: "1",
    is_in_ue: "0"
  },
  {
    symbol: "VC",
    currency: "XCD",
    polish_name: "Saint Vincent i Grenadyny",
    english_name: "Saint Vincent and the Grenadines",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "VE",
    currency: "VEF",
    polish_name: "Wenezuela",
    english_name: "Venezuela",
    root_name: "Republica Bolivariana de Venezuela",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "VG",
    currency: "USD",
    polish_name: "Wyspy Dziewicze - Brytyjskie",
    english_name: "British Virgin Islands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "VI",
    currency: "USD",
    polish_name: "Wyspy Dziewicze - USA",
    english_name: "United States Virgin Islands",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "VN",
    currency: "VND",
    polish_name: "Wietnam",
    english_name: "Vietnam",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "VU",
    currency: "VUV",
    polish_name: "Vanuatu",
    english_name: "Vanuatu",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "WF",
    currency: "XPF",
    polish_name: "Wallis i Futuna",
    english_name: "Wallis and Futuna",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "WS",
    currency: "WST",
    polish_name: "Samoa",
    english_name: "Samoa",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "XC",
    currency: "EUR",
    polish_name: "Ceuta",
    english_name: "Ceuta",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "XJ",
    currency: "SSP",
    polish_name: "Sudan Po\u0142udniowy",
    english_name: "Southern Sudan",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "XL",
    currency: "EUR",
    polish_name: "Melilla",
    english_name: "Melilla",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "YE",
    currency: "YER",
    polish_name: "Jemen",
    english_name: "Yemen",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "YT",
    currency: "EUR",
    polish_name: "Majotta",
    english_name: "Majotta",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "ZA",
    currency: "ZAR",
    polish_name: "Republika Po\u0142udniowej Afryki",
    english_name: "Republic of South Africa",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "ZM",
    currency: "ZMK",
    polish_name: "Zambia",
    english_name: "Republic of Zambia",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  },
  {
    symbol: "ZW",
    currency: "USD",
    polish_name: "Zimbabwe",
    english_name: "Zimbabwe",
    root_name: "",
    is_in_europe: "0",
    is_in_ue: "0"
  }
];

import vue from "../main";

export default countryList;

export function getTranslatedCountryName(countrySymbol, language = null) {
  let country = countryList.find(v => v.symbol === countrySymbol.toUpperCase());
  if (language != null) {
    return language.toUpperCase() === "PL" ? country.polish_name : country.english_name;
  }
  return vue.$i18n.locale === "pl" ? country.polish_name : country.english_name;
}
